import { z, ZodType } from 'zod';
import { get, set } from 'radash';

const synchronize = <T extends ZodType>(
    schema: T,
    attributes: {
        [key: string]: string[];
    },
): z.ZodEffects<T> => {
    return z.preprocess<T>((object) => {
        let clone = object ? JSON.parse(JSON.stringify(object)) : {};

        Object.entries(attributes).forEach(([source, targets]) => {
            const value = get(clone, source);

            targets.forEach((key) => {
                clone = set(clone, key, value);
            });
        });

        return clone;
    }, schema);
};

export { synchronize };
